
import { TimecardRow } from "../models/timecardrow";

export class Template {
    name: string = '';
    timeCardRows: Array<TimecardRow> = new Array<TimecardRow>();

    constructor() {
    }
}
